import type { ReactNode } from "react";
import { classes } from "../../nucleo/classes";

export type EstadoDoChip = "ok" | "atencao" | "erro" | "neutro" | "aguardando";

const CLASSES: Record<EstadoDoChip, string> = {
  ok: "chip--ok",
  atencao: "chip--atencao",
  erro: "chip--erro",
  neutro: "chip--neutro",
  aguardando: "chip--aguardando",
};

/** Rótulo curto de estado — o que o protótipo chama de `.chip`. */
export interface PropsDoChip {
  estado: EstadoDoChip;
  children: ReactNode;
  /** Some com o ponto colorido quando a cor já não é o portador da informação. */
  semPonto?: boolean;
  className?: string;
  "data-testid"?: string;
}

export function Chip({
  estado,
  children,
  semPonto = false,
  className,
  ...resto
}: PropsDoChip) {
  return (
    <span
      className={classes("chip", CLASSES[estado], className)}
      // O estado também vai como atributo: a cor sozinha não serve nem para quem não a
      // enxerga nem para o teste automatizado.
      data-estado={estado}
      {...resto}
    >
      {semPonto ? null : <span className="chip__ponto" aria-hidden="true" />}
      {children}
    </span>
  );
}
